import { CREATE_OBJECT, TASK, WAIT_UNTIL } from 'automation-ui-action-features/constants/ActionTypes';
export const getSourceActionTypesForDestination = ({
  destinationActionType
}) => {
  switch (destinationActionType) {
    case WAIT_UNTIL:
      return [TASK, CREATE_OBJECT];
    //
    // TODO: add more here as we unlock more data passing actions
    //
    default:
      return [];
  }
};
export const getIsValidActionForDataSource = ({
  action,
  destinationActionType
}) => {
  const sourceActionType = action.getActionType();
  return getSourceActionTypesForDestination({
    destinationActionType
  }).includes(sourceActionType);
};